import React, { Component } from 'react';
import { ColorPicker, BasePopoverPanel } from 'crazyEditor/components/EditorUI/BaseUI/index';
import _ from 'lodash';
import { connect } from 'react-redux';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { setElementUpdatePreview, applyElementUpdatePreview } from 'crazyEditor/redux/modules/element/actions/previewElementActions';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import Slider from 'material-ui/Slider';
import TextField from 'material-ui/TextField';
import { getNormalizedDesktopElements } from 'crazyEditor/redux/modules/element/elementSelectors';
import InputWrapper from 'crazyEditor/components/EditorUI/BaseUI/InputWrapper/InputWrapper';

const MAX_GROWTH_PERCENT = 400;

@connect(
  (state) => ({
    desktopElements: getNormalizedDesktopElements(state)
  }),
  {closeLazyPanel, setElementUpdatePreview, applyElementUpdatePreview}
)
@Radium
export default class MobileFontSizePanel extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialStateFromProps(props);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState(this.getInitialStateFromProps(nextProps));
    }
  }

  onChange = (sliderValue) => {
    const { setElementUpdatePreview } = this.props;
    if (_.isNumber(sliderValue) && sliderValue > 0) {
      const element = _.get(this.props, 'panelProps.selectedElements[0]');
      const elementMethods = getElementMethods(element.type);
      setElementUpdatePreview(element.id, elementMethods.getFontSizeSetterByPercentFromDesktopElement(element, sliderValue));
      this.setState({sliderValue});
    } else {
      this.setState({sliderValue: 0});
    }
  };

  onClose = () => {
    const { closeLazyPanel, panelName, applyElementUpdatePreview} = this.props;

    applyElementUpdatePreview(true);
    closeLazyPanel(panelName);
  };

  getInitialStateFromProps(props) {
    const element = _.get(props, 'panelProps.selectedElements[0]');
    const desktopElement = props.desktopElements[element.desktopId];
    const elementMethods = getElementMethods(element.type);
    const desktopElementFontSize = elementMethods.getFontSize(desktopElement);
    const elementFontSize = elementMethods.getFontSize(element);
    return {
      fontSize: desktopElementFontSize,
      sliderValue: _.isNil(elementFontSize) ? 100 : Math.min(elementMethods.getFontSizeInPercentFromDesktop(element), MAX_GROWTH_PERCENT)
    };
  }

  render() {
    const { panelName, anchorEl, open } = this.props;
    const { sliderValue } = this.state;
    return (
      <BasePopoverPanel
        panelName={panelName}
        anchorEl={anchorEl}
        open={open}
        onRequestClose={this.onClose}
        style={{width: 320, paddingTop: 23, paddingLeft: 23, paddingRight: 23, fontSize: 16}}
      >
        Font Size (%)
        <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
          <Slider value={sliderValue} min={0} max={MAX_GROWTH_PERCENT} step={1} style={{width: 215}} ref="slider"
                  onChange={(event, value) => this.onChange(value)}/>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <InputWrapper value={`${sliderValue}`} defaultValue={0} style={{width: 45}}
                          inputStyle={{textAlign: 'center'}} type="number"
                          onChange={(event) => this.onChange(parseInt(event.target.value, 10))}/>
            <span>%</span>
          </div>
        </div>
      </BasePopoverPanel>
    );
  }
}

MobileFontSizePanel.propTypes = {
  panelName: PropTypes.string.isRequired,
  anchorEl: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  panelProps: PropTypes.object
};